import { useState, useContext } from 'react';
import { IonContent, IonIcon, IonPage, IonGrid, IonRow, IonCol, IonInput, IonButton, useIonViewDidEnter } from '@ionic/react';
import axios from 'axios';
import Navbar from '../../components/Navbar';
import './styles.css';
import { ServerUrl, GetCurrentYear } from '../../constants';
import { AppContext } from "../../context/appContext";
import MonthlyTypeEnum from "../../enum/monthly-type-enum";
import { arrowForwardCircle } from 'ionicons/icons';
import { MonthlyDataHelper } from '../../services/monthly-data-helper';

const MonthNames = [
  "September",
  "October",
  "November",
  "December",
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August"
];

const Home: React.FC = () => {
  const { CurrentUser } = useContext(AppContext);
  const token = CurrentUser ? CurrentUser.token : null;
  const groupName = CurrentUser ? CurrentUser.group : '';

  const [MonthRowStates, SetMonthRowStates] = useState<Array<{ name: string, isEqualSum: boolean }>>([
    { name: "September", isEqualSum: true },
    { name: "October", isEqualSum: true },
    { name: "November", isEqualSum: true },
    { name: "December", isEqualSum: true },
    { name: "January", isEqualSum: true },
    { name: "February", isEqualSum: true },
    { name: "March", isEqualSum: true },
    { name: "April", isEqualSum: true },
    { name: "May", isEqualSum: true },
    { name: "June", isEqualSum: true },
    { name: "July", isEqualSum: true },
    { name: "August", isEqualSum: true }
  ]);

  const [MonthBoardRowStates, SetMonthBoardRowStates] = useState<Array<{ name: string, isEqualSum: boolean }>>([
    { name: "September", isEqualSum: true },
    { name: "October", isEqualSum: true },
    { name: "November", isEqualSum: true },
    { name: "December", isEqualSum: true },
    { name: "January", isEqualSum: true },
    { name: "February", isEqualSum: true },
    { name: "March", isEqualSum: true },
    { name: "April", isEqualSum: true },
    { name: "May", isEqualSum: true },
    { name: "June", isEqualSum: true },
    { name: "July", isEqualSum: true },
    { name: "August", isEqualSum: true }
  ]);

  const [CurrentTotal, SetCurrentTotal] = useState<Array<any>>([]);
  const [CurrentBoard, SetCurrentBoard] = useState<Array<any>>([]);
  const [PreviousTotal, SetPreviousTotal] = useState<Array<any>>([]);
  const [PreviousBoard, SetPreviousBoard] = useState<Array<any>>([]);

  const [TotalNonEscWorksSum, SetTotalNonEscWorksSum] = useState<string>('');
  const [TotalEscWorksDashboardSum, SetTotalEscWorksDashboardSum] = useState<string>('');
  const [TotalCurrentSum, SetTotalCurrentSum] = useState<string>('');
  const [TotalPreviousSum, SetTotalPreviousSum] = useState<string>('');
  const [growTarget, SetGrowTarget] = useState<string>('');

  const [TotalBoardNonEscWorksSum, SetTotalBoardNonEscWorksSum] = useState<string>('');
  const [TotalBoardEscWorksDashboardSum, SetTotalBoardEscWorksDashboardSum] = useState<string>('');
  const [BoardCurrentSum, SetBoardCurrentSum] = useState<string>('');
  const [BoardPreviousSum, SetBoardPreviousSum] = useState<string>('');

  const currentYear = GetCurrentYear() - 2000;
  let current_year = currentYear + '-' + (currentYear + 1);
  let previous_year = (currentYear - 1) + '-' + currentYear;

  const currentFullYear = GetCurrentYear();
  let current_full_year = currentFullYear + ' - ' + (currentFullYear + 1);
  let previous_full_year = (currentFullYear - 1) + ' - ' + currentFullYear;

  useIonViewDidEnter(() => {
    LoadData();
  });

  const totalUrl = `${ServerUrl}/monthly/2.1a/total`;
  const boardUrl = `${ServerUrl}/monthly/2.1a/board`;

  const totalSubmittedUrl = `${ServerUrl}/monthly/2.1a/totalSubmitted`;
  const totalBoardSubmittedUrl = `${ServerUrl}/monthly/2.1a/boardSubmitted`;

  const LoadData = () => {
    axios.get(`${totalUrl}?year=${current_year}`, {
        headers: {
          'Authorization': "Bearer " + token,          
        }
      }).then(res => {
        if (res.data && res.data.length > 0) {
          SetCurrentTotal(res.data);
          SetTotalCurrentSum(getSum(res.data, current_year));
          SetTotalNonEscWorksSum(getSum(res.data, current_year, MonthlyTypeEnum.NonEscWorksData));
          SetTotalEscWorksDashboardSum(getSum(res.data, current_year, MonthlyTypeEnum.EscWorksDashboardData));

          setMonthRawStates(res.data);
        }
    }, err => {
      alert("Fail to get data. " + JSON.stringify(err))
    });

    axios.get(`${totalUrl}?year=${previous_year}`, {
      headers: {
        'Authorization': "Bearer " + token,          
      }
    }).then(res => {
      if (res.data && res.data.length > 0) {
        SetPreviousTotal(res.data);
        let previousSum = getSum(res.data, previous_year);
        let target = (parseFloat(previousSum) * 1.03).toFixed(2);
        SetTotalPreviousSum(previousSum);
        SetGrowTarget(target);
      }
    }, err => {
      console.log("Fail to get data. " + JSON.stringify(err))
    });

    axios.get(`${boardUrl}?year=${current_year}`, {
      headers: {
        'Authorization': "Bearer " + token,          
      }
      }).then(res => {
        if (res.data && res.data.length > 0) {
          SetCurrentBoard(res.data);
          SetBoardCurrentSum(getSum(res.data, current_year));

          SetTotalBoardNonEscWorksSum(getSum(res.data, current_year, MonthlyTypeEnum.NonEscWorksData));
          SetTotalBoardEscWorksDashboardSum(getSum(res.data, current_year, MonthlyTypeEnum.EscWorksDashboardData));

          setMonthBoardRawStates(res.data);
        }
    }, err => {
      alert("Fail to get data. " + JSON.stringify(err))
    });

    axios.get(`${boardUrl}?year=${previous_year}`, {
      headers: {
        'Authorization': "Bearer " + token,          
      }
    }).then(res => {
      if (res.data && res.data.length > 0) {
        SetPreviousBoard(res.data);
        SetBoardPreviousSum(getSum(res.data, previous_year));
      }
    }, err => {
      console.log("Fail to get data. " + JSON.stringify(err))
    });
  };

  const getData = (dataArray: Array<any>, name: string, monthlyType: MonthlyTypeEnum = MonthlyTypeEnum.Default) => {
    let num = 0;

    let element = dataArray.find(e => e.month === name);
    if (element) {
      num = parseFloat(MonthlyDataHelper.getDataByMontlyType(element, monthlyType));
    }

    return num;
  }

  const saveTotalData = (month: string, value: any, year: string, current: boolean, monthlyType: MonthlyTypeEnum) => {
    axios.post(totalUrl, {"month": month, "value": value, "year": year, "monthlyType": monthlyType}, {
      headers: {
        'Authorization': "Bearer " + token,          
      }
    }).then(res => {
      if (current) {
        SetCurrentTotal(res.data);
        SetTotalCurrentSum(getSum(res.data, current_year));
        SetTotalNonEscWorksSum(getSum(res.data, current_year, MonthlyTypeEnum.NonEscWorksData));
        SetTotalEscWorksDashboardSum(getSum(res.data, current_year, MonthlyTypeEnum.EscWorksDashboardData));
      }
      else {
        SetPreviousTotal(res.data);
        let previousSum = getSum(res.data, previous_year);
        let target = (parseFloat(previousSum) * 1.03).toFixed(2);
        SetTotalPreviousSum(previousSum);
        SetGrowTarget(target);
      }
    })
  }

  const saveBoardData = (month: string, value: any, year: string, current: boolean, monthlyType: MonthlyTypeEnum) => {
    axios.post(boardUrl, {"month": month, "value": value, "year": year, "monthlyType": monthlyType}, {
      headers: {
        'Authorization': "Bearer " + token,          
      }
    }).then(res => {
      if (current) {
        SetCurrentBoard(res.data);
        SetBoardCurrentSum(getSum(res.data, current_year));
        SetTotalBoardNonEscWorksSum(getSum(res.data, current_year, MonthlyTypeEnum.NonEscWorksData));
        SetTotalBoardEscWorksDashboardSum(getSum(res.data, current_year, MonthlyTypeEnum.EscWorksDashboardData));
      }
      else {
        SetPreviousBoard(res.data);
        SetBoardPreviousSum(getSum(res.data, previous_year));
      }
    })
  }

  const getSum = (data: Array<any>, year: string, monthlyType: MonthlyTypeEnum = MonthlyTypeEnum.Default): string => {
    let sum = 0;
    data.filter(element => element.year === year).forEach(item => sum += parseFloat(MonthlyDataHelper.getDataByMontlyType(item, monthlyType)));
    return sum === 0 ? "0" : sum.toLocaleString();
  }

  const setMonthRawStates = (inititalData: Array<any>) => {
    const yearDataArray = inititalData.filter(element => element.year === current_year);
    yearDataArray.forEach(monthData => {
      updateMonthRowStates(monthData.month, current_year, monthData.nonEscWorksData, monthData.escWorksDashboardData, monthData.trainContactHours);
    });
  }

  const setMonthBoardRawStates = (inititalData: Array<any>) => {
    const yearDataArray = inititalData.filter(element => element.year === current_year);
    yearDataArray.forEach(monthData => {
      updateMonthBoardRowStates(monthData.month, current_year, monthData.nonEscWorksData, monthData.escWorksDashboardData, monthData.trainContactHours);
    });
  }

  const updateNonEscEorksData = (month: string, value: any, year: string, current: boolean, monthlyType: MonthlyTypeEnum) => {
    saveTotalData(month, value, year, current, monthlyType);

    updateMonthRowStates(month, year, value);
  }

  const updateBoardNonEscEorksData = (month: string, value: any, year: string, current: boolean, monthlyType: MonthlyTypeEnum) => {
    saveBoardData(month, value, year, current, monthlyType);

    updateMonthBoardRowStates(month, year, value);
  }

  const updateMonthBoardRowStates = (month: string,  year: string, nonEscWorksValue: any, 
    escWorksDashboardValue: any = null, submittedValue: any = null) => 
    {
    SetMonthBoardRowStates(prevMonthState => {
      const newState = prevMonthState.map(prevMonth => {

        if (prevMonth.name == month) {
          return {...prevMonth, isEqualSum: MonthlyDataHelper.isSumEqual(CurrentBoard, month, year, nonEscWorksValue, escWorksDashboardValue, submittedValue)};
        }

        return prevMonth;
      });

      return newState;
    });
  }

  const updateMonthRowStates = (month: string,  year: string, nonEscWorksValue: any, 
      escWorksDashboardValue: any = null, submittedValue: any = null) => {
    SetMonthRowStates(prevMonthState => {
      const newState = prevMonthState.map(prevMonth => {

        if (prevMonth.name == month) {
          return {...prevMonth, isEqualSum: MonthlyDataHelper.isSumEqual(CurrentTotal, month, year, nonEscWorksValue, escWorksDashboardValue, submittedValue)};
        }

        return prevMonth;
      });

      return newState;
    });
  }

  const updateSubmittedData = (month: string) => {
    const monthData = CurrentTotal.find(element => element.year === current_year && element.month == month);
    const floatEscWorksDashBoardValue = MonthlyDataHelper.tryParseFloat(monthData.escWorksDashboardData).parsedValue;
    const floatNonEscWorksValue = MonthlyDataHelper.tryParseFloat(monthData.nonEscWorksData).parsedValue;
    const updatedValue = floatEscWorksDashBoardValue + floatNonEscWorksValue

    axios.post(totalSubmittedUrl, {"month": month, "value": updatedValue, "year": current_year}, {
      headers: {
        'Authorization': "Bearer " + token,          
      }
    }).then(res => {
      SetCurrentTotal(res.data);
      SetTotalCurrentSum(getSum(res.data, current_year));
      SetTotalNonEscWorksSum(getSum(res.data, current_year, MonthlyTypeEnum.NonEscWorksData));
      SetTotalEscWorksDashboardSum(getSum(res.data, current_year, MonthlyTypeEnum.EscWorksDashboardData));

      setMonthRawStates(res.data);
    })
  }

  const updateBoardSubmittedData = (month: string) => {
    const monthData = CurrentBoard.find(element => element.year === current_year && element.month == month);
    const floatEscWorksDashBoardValue = MonthlyDataHelper.tryParseFloat(monthData.escWorksDashboardData).parsedValue;
    const floatNonEscWorksValue = MonthlyDataHelper.tryParseFloat(monthData.nonEscWorksData).parsedValue;
    const updatedValue = floatEscWorksDashBoardValue + floatNonEscWorksValue

    axios.post(totalBoardSubmittedUrl, {"month": month, "value": updatedValue, "year": current_year, "monthlyType": "monthlyType"}, {
      headers: {
        'Authorization': "Bearer " + token,          
      }
    }).then(res => {
      SetCurrentBoard(res.data);
      SetBoardCurrentSum(getSum(res.data, current_year));
      SetTotalBoardNonEscWorksSum(getSum(res.data, current_year, MonthlyTypeEnum.NonEscWorksData));
      SetTotalBoardEscWorksDashboardSum(getSum(res.data, current_year, MonthlyTypeEnum.EscWorksDashboardData));

      setMonthBoardRawStates(res.data);
    })
  }

  const onSaveExcel = () => {
    axios.get(`${ServerUrl}/monthly/2.1/excel?current=${current_year}&previous=${previous_year}`, {
      headers: {
        'Authorization': "Bearer " + token,          
      },
      responseType: 'blob',
    }).then(res => {
      const url = window.URL.createObjectURL(new Blob([res.data],
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download','Monthly 2.1.xlsx');
        document.body.appendChild(link);
        link.click();
    }); 
  }

  return (
    <IonPage>
      <Navbar />
      <IonContent fullscreen>
          <div className='title-container'>
            <div style={{marginBottom: '10px', marginTop: '20px'}}>{groupName}</div>
            <div style={{marginBottom: '20px'}}>Indicator 2.1 - Number of Individuals Trained </div>
            <IonButton color="primary" style={{textTransform:'none'}} onClick = {onSaveExcel}>Export to Excel</IonButton>
          </div>
          <div className='flex-container'>
            <div style={{flexGrow: 3}}>
              <IonGrid>
                <IonRow>
                  <IonCol offset="4" size="8" className="no-border"><span>Total Individuals Trained</span></IonCol>
                </IonRow>
                <IonRow>
                  <IonCol className='data-row no-border'></IonCol>
                              <IonCol style={{ fontSize: '14px', display: 'none' }} className='data-row'>
                    <IonInput min='0'  value="Non-escWorks Data" readonly />
                  </IonCol>
                              <IonCol size="auto" style={{ fontSize: '14px', display: 'none' }} className='data-row'>
                    <IonInput style={{width: '180px'}} min='0' value="escWorks Dashboard Data" readonly />
                  </IonCol>
                  <IonCol style={{fontSize: '14px'}} className='data-row'>
                    <IonInput className="ion-input-padding" min='0'  value="Submitted Data" readonly />
                  </IonCol>
                  <IonCol style={{fontSize: '14px'}} className='data-row right-border'>
                    <IonInput min='0'  value="Prior Year" readonly />
                  </IonCol>
                </IonRow>
                <IonRow className="header-row">
                  <IonCol className='data-row no-border'></IonCol>
                              <IonCol className='data-row table-header' style={{ display: 'none' }}>
                    <IonInput min='0'  value={current_full_year} readonly />
                  </IonCol>
                              <IonCol size="auto" className='data-row table-header' style={{ display: 'none' }}>
                    <IonInput style={{width: '180px'}} min='0'  value={current_full_year} readonly />
                  </IonCol>
                  <IonCol className='data-row table-header'>
                    <IonInput min='0'  value={current_full_year} readonly />
                  </IonCol>
                  <IonCol className='data-row right-border table-header'>
                    <IonInput min='0'  value={previous_full_year} readonly />
                  </IonCol>
                </IonRow>
                {
                  MonthRowStates.map((state, index) => {
                    if (state.isEqualSum) {
                      return (
                        <IonRow key={index} className={(index % 2) === 0 ? "dark-row" : "light-row"}>
                          <IonCol className='data-row'>
                            <IonInput min='0'  value={state.name} readonly />
                          </IonCol>
                              <IonCol className='data-row' style={{ display: 'none' }}>
                            <IonInput min='0'  type="number" step="1" value={getData(CurrentTotal, state.name, MonthlyTypeEnum.NonEscWorksData)} placeholder="" onBlur={(e) => {
                                updateNonEscEorksData(state.name, e.target.value, current_year, true, MonthlyTypeEnum.NonEscWorksData);
                              }}>     
                            </IonInput>
                          </IonCol>
                              <IonCol size="auto" className='data-row' style={{ display: 'none' }}>
                            <IonInput style={{width: '180px'}} min='0' readonly  type="number" step="1" value={getData(CurrentTotal, state.name, MonthlyTypeEnum.EscWorksDashboardData)} placeholder="" onBlur={(e) => {
                                //saveTotalData(name, e.target.value, current_year, true);
                              }}>     
                            </IonInput>
                          </IonCol>
                          <IonCol className='data-row'>
                            <IonInput min='0'  type="number" step="1" value={getData(CurrentTotal, state.name)} placeholder="" onBlur={(e) => {
                                saveTotalData(state.name, e.target.value, current_year, true, MonthlyTypeEnum.Default);
                              }}>     
                            </IonInput>
                          </IonCol>
                          <IonCol className='data-row right-border'>
                            <IonInput min='0'  readonly type="number" step="1" value={getData(PreviousTotal, state.name)} placeholder="" onBlur={(e) => {
                                // saveTotalData(name, e.target.value, previous_year, false);
                              }}>    
                            </IonInput>
                          </IonCol>                        
                        </IonRow>
                      )
                    }
                    else{
                      return (
                        <IonRow key={index}>
                              <IonCol className='data-row highlighted-row'>
                            <IonInput min='0'  value={state.name} readonly />
                          </IonCol>
                              <IonCol className='data-row highlighted-row' style={{ display: 'none' }}>
                            <IonInput min='0'  type="number" step="1" value={getData(CurrentTotal, state.name, MonthlyTypeEnum.NonEscWorksData)} placeholder="" onBlur={(e) => {
                                updateNonEscEorksData(state.name, e.target.value, current_year, true, MonthlyTypeEnum.NonEscWorksData);
                              }}>     
                            </IonInput>
                          </IonCol>
                              <IonCol size="auto" className='data-row highlighted-row' style={{ display: 'none' }}>
                            <IonInput style={{width: '180px'}} min='0' readonly  type="number" step="1" value={getData(CurrentTotal, state.name, MonthlyTypeEnum.EscWorksDashboardData)} placeholder="" onBlur={(e) => {
                                //saveTotalData(name, e.target.value, current_year, true);
                              }}>     
                            </IonInput>
                            <IonButton fill="clear" onClick={() => updateSubmittedData(state.name)} className="arrow-button">
                              <IonIcon icon={arrowForwardCircle} />
                            </IonButton>
                          </IonCol>
                          <IonCol className='data-row highlighted-row'>
                            <IonInput min='0'  type="number" step="1" value={getData(CurrentTotal, state.name)} placeholder="" onBlur={(e) => {
                                saveTotalData(state.name, e.target.value, current_year, true, MonthlyTypeEnum.Default);
                              }}>     
                            </IonInput>
                          </IonCol>
                          <IonCol className='data-row right-border'>
                            <IonInput min='0'  readonly type="number" step="1" value={getData(PreviousTotal, state.name)} placeholder="" onBlur={(e) => {
                                // saveTotalData(name, e.target.value, previous_year, false);
                              }}>    
                            </IonInput>
                          </IonCol>                      
                        </IonRow>
                      )
                    }
                  })
                }
                <IonRow>
                  <IonCol className='data-row top-border'></IonCol>
                              <IonCol className='data-row bottom-border table-header foot-text-color' style={{ display: 'none' }}>
                    <div style={{paddingRight: '14px'}}>
                      <IonInput value={TotalNonEscWorksSum} readonly />
                    </div>
                  </IonCol>
                              <IonCol size="auto" className='data-row bottom-border table-header foot-text-color' style={{ display: 'none' }}>
                    <div style={{paddingRight: '14px', width: '180px'}}>
                      <IonInput value={TotalEscWorksDashboardSum} readonly />
                    </div>
                  </IonCol>
                  <IonCol className='data-row bottom-border table-header foot-text-color'>
                    <div style={{paddingRight: '14px'}}>
                      <IonInput value={TotalCurrentSum} readonly />
                    </div>
                  </IonCol>
                  <IonCol className='data-row bottom-border right-border table-header foot-text-color'>
                    <div style={{paddingRight: '14px'}}>
                      <IonInput value={TotalPreviousSum} readonly />
                    </div>
                  </IonCol>
                </IonRow>
              </IonGrid>
            </div>
            <div style={{flexGrow: 3}}>
              <IonGrid>
                <IonRow>
                  <IonCol offset="4" size="8" className="no-border"><span>Board Members Trained</span></IonCol>
                </IonRow>
                <IonRow>
                  <IonCol className='data-row no-border'></IonCol>
                  <IonCol style={{fontSize: '14px',display:'none'}} className='data-row'>
                    <IonInput min='0'  value="Non-escWorks Data" readonly />
                  </IonCol>
                  <IonCol size="auto" style={{fontSize: '14px', display:'none'}} className='data-row'>
                    <IonInput style={{width: '180px'}} min='0' value="escWorks Dashboard Data" readonly />
                  </IonCol>
                  <IonCol style={{fontSize: '14px'}} className='data-row'>
                    <IonInput className="ion-input-padding" min='0'  value="Submitted Data" readonly />
                  </IonCol>
                  <IonCol style={{fontSize: '14px'}} className='data-row right-border'>
                    <IonInput min='0'  value="Prior Year" readonly />
                  </IonCol>
                </IonRow>
                <IonRow className="header-row">
                  <IonCol className='data-row no-border'></IonCol>
                              <IonCol className='data-row table-header' style={{ display: 'none' }}>
                    <IonInput min='0'  value={current_full_year} readonly />
                  </IonCol>
                              <IonCol size="auto" className='data-row table-header' style={{ display: 'none' }}>
                    <IonInput style={{width: '180px'}} min='0'  value={current_full_year} readonly />
                  </IonCol>
                  <IonCol className='data-row table-header'>
                    <IonInput min='0'  value={current_full_year} readonly />
                  </IonCol>
                  <IonCol className='data-row right-border table-header'>
                    <IonInput min='0'  value={previous_full_year} readonly />
                  </IonCol>
                </IonRow>
                {
                  MonthBoardRowStates.map((state, index) => {
                    if (state.isEqualSum) {
                      return (
                        <IonRow key={index} className={(index % 2) === 0 ? "dark-row" : "light-row"}>
                          <IonCol className='data-row'>
                            <IonInput min='0'  value={state.name} readonly />
                          </IonCol>
                              <IonCol className='data-row' style={{ display: 'none' }}>
                            <IonInput min='0'  type="number" step="1" value={getData(CurrentBoard, state.name, MonthlyTypeEnum.NonEscWorksData)} placeholder="" onBlur={(e) => {
                                updateBoardNonEscEorksData(state.name, e.target.value, current_year, true, MonthlyTypeEnum.NonEscWorksData);
                              }}>     
                            </IonInput>
                          </IonCol>
                              <IonCol size="auto" className='data-row' style={{ display: 'none' }}>
                            <IonInput style={{width: '180px'}} min='0' readonly  type="number" step="1" value={getData(CurrentBoard, state.name, MonthlyTypeEnum.EscWorksDashboardData)} placeholder="" onBlur={(e) => {
                                //saveBoardData(name, e.target.value, current_year, true);
                              }}>     
                            </IonInput>
                          </IonCol>
                          <IonCol className='data-row'>
                            <IonInput min='0'  type="number" step="1" value={getData(CurrentBoard, state.name)} placeholder="" onBlur={(e) => {
                                saveBoardData(state.name, e.target.value, current_year, true, MonthlyTypeEnum.Default);
                              }}>     
                            </IonInput>
                          </IonCol>
                          <IonCol className='data-row right-border'>
                            <IonInput min='0'  readonly type="number" step="1" value={getData(PreviousBoard, state.name)} placeholder="" onBlur={(e) => {
                                // saveBoardData(name, e.target.value, previous_year, false);
                              }}>    
                            </IonInput>
  
                          </IonCol>                        
                        </IonRow>
                      )
                    }
                    else{
                      return (
                        <IonRow key={index}>
                          <IonCol className='data-row highlighted-row'>
                            <IonInput min='0'  value={state.name} readonly />
                          </IonCol>
                              <IonCol className='data-row highlighted-row' style={{ display: 'none' }}>
                            <IonInput min='0'  type="number" step="1" value={getData(CurrentBoard, state.name, MonthlyTypeEnum.NonEscWorksData)} placeholder="" onBlur={(e) => {
                                updateBoardNonEscEorksData(state.name, e.target.value, current_year, true, MonthlyTypeEnum.NonEscWorksData);
                              }}>     
                            </IonInput>
                          </IonCol>
                              <IonCol size="auto" className='data-row highlighted-row' style={{ display: 'none' }}>
                            <IonInput style={{width: '180px'}} min='0' readonly  type="number" step="1" value={getData(CurrentBoard, state.name, MonthlyTypeEnum.EscWorksDashboardData)} placeholder="" onBlur={(e) => {
                                //saveTotalData(name, e.target.value, current_year, true);
                              }}>     
                            </IonInput>
                            <IonButton fill="clear" onClick={() => updateBoardSubmittedData(state.name)} className="arrow-button">
                              <IonIcon icon={arrowForwardCircle} />
                            </IonButton>
                          </IonCol>
                          <IonCol className='data-row highlighted-row'>
                            <IonInput min='0'  type="number" step="1" value={getData(CurrentBoard, state.name)} placeholder="" onBlur={(e) => {
                                saveBoardData(state.name, e.target.value, current_year, true, MonthlyTypeEnum.Default);
                              }}>     
                            </IonInput>
                          </IonCol>
                          <IonCol className='data-row right-border'>
                            <IonInput min='0'  readonly type="number" step="1" value={getData(PreviousBoard, state.name)} placeholder="" onBlur={(e) => {
                                // saveTotalData(name, e.target.value, previous_year, false);
                              }}>    
                            </IonInput>
                          </IonCol>                      
                        </IonRow>
                      )
                    }
                  })
                }
                <IonRow>
                  <IonCol className='data-row top-border'></IonCol>
                              <IonCol className='data-row bottom-border table-header foot-text-color' style={{ display: 'none' }}>
                    <div style={{paddingRight: '14px'}}>
                      <IonInput value={TotalBoardNonEscWorksSum} readonly />
                    </div>
                  </IonCol>
                              <IonCol size="auto" className='data-row bottom-border table-header foot-text-color' style={{ display: 'none' }}>
                    <div style={{paddingRight: '14px', width: '180px'}}>
                      <IonInput value={TotalBoardEscWorksDashboardSum} readonly />
                    </div>
                  </IonCol>
                  <IonCol className='data-row bottom-border table-header foot-text-color'>
                    <div style={{paddingRight: '14px'}}>
                      <IonInput min='0'  value={BoardCurrentSum} readonly />
                    </div>
                  </IonCol>
                  <IonCol className='data-row bottom-border right-border table-header foot-text-color'>
                    <div style={{paddingRight: '14px'}}>
                      <IonInput min='0'  value={BoardPreviousSum} readonly />
                    </div>
                  </IonCol>
                </IonRow>
              </IonGrid>
            </div>
          </div>

      </IonContent>
    </IonPage>
  );
};

export default Home;